function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 9.75 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FYI-Document-Icons",
  transform: "translate(-216.000000, -634.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Image",
  transform: "translate(0.000000, 606.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Main",
  transform: "translate(216.000000, 28.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#E3E7F4",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-path",
  fill: "#FFBC00",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  cx: 11.5,
  cy: 21.5,
  r: 5.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.0352135,19.714854 C18.5196178,18.7813436 17.6375259,18.7589782 17.0757575,19.6662337 L14.3140499,24.1266633 C13.7522814,25.0339188 12.6335542,25.3217512 11.8274549,24.766507 C11.0203937,24.2112627 9.8016255,24.4242198 9.11672971,25.2390966 L6.36560337,28.5170797 C5.68070758,29.3339014 5.98660205,30 7.04472756,30 L22.7992546,30 C23.8573801,30 24.3008309,29.2366607 23.7842732,28.3021778 L19.0352135,19.714854 Z",
  id: "Combined-Shape",
  fill: "#1ECA7F",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#CFD4E5",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
})))));

var SvgImage = function SvgImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image.3c503494.svg";
export { ForwardRef as ReactComponent };